<script lang="ts">
  import { Faq } from '@squareup/public-web-design-system';
  import DynamicChildrenComponent from '$lib/components/DynamicChildrenComponent/DynamicChildrenComponent.svelte';
  import type { FaqModuleProps } from './types';

  export let entryId: FaqModuleProps['entryId'];
  export let customCssClass: FaqModuleProps['customCssClass'];
  export let colorMode: FaqModuleProps['colorMode'];
  export let heading: FaqModuleProps['heading'];
  export let options: FaqModuleProps['options'];
  export let items: FaqModuleProps['items'];

  function handleClick(index: number): void {
    window.Sq.Tracking.track(
      {
        action: 'Content Explorer',
        properties: {
          question: items[index].question,
        },
      },
      { destinations: ['cdp'] }
    );
  }
</script>

<Faq
  class="FaqModule {customCssClass}"
  data-entry-id={entryId}
  {colorMode}
  headingText={heading}
  isFirstItemOpen={options.isFirstItemOpen}
  onClick={(index) => handleClick(index)}
  {items}
>
  <!-- https://svelte.dev/docs/svelte/legacy-slots#Passing-data-to-slotted-content -->
  <!-- Use a slot to pass values back to the parent using props where The parent exposes the values to the template
   using the let: directive -->
  <svelte:fragment slot="content" let:answer>
    <div class="RichTextFieldComponent">
      <DynamicChildrenComponent children={[answer]} />
    </div>
  </svelte:fragment>
</Faq>
